import React, { useEffect } from 'react';

import { IntlProvider } from 'react-intl';

import ChildrenPropType from '../prop-types/children';
import LogService from '../services/log-service';
import formatters from './formatters';
import { useLocale, useMessagesForLocale } from './hooks';
import { English } from './locale-context-provider/locale-codes';
import { changeLocaleForMoment } from './moment-locale';

const DEFAULT_LOCALE = English;
const missingTranslationErrorCode = 'MISSING_TRANSLATION';

const onReactIntlError = (message) => {
  if (message.code !== missingTranslationErrorCode) {
    LogService.logError(message);
  }
};

const InternationalProvider = ({ children }) => {
  const { locale = DEFAULT_LOCALE } = useLocale();
  const messages = useMessagesForLocale(locale);

  useEffect(() => {
    changeLocaleForMoment(locale);
  }, [locale]);

  return (
    <IntlProvider defaultRichTextElements={formatters} locale={locale} messages={messages} onError={onReactIntlError}>
      {children}
    </IntlProvider>
  );
};

InternationalProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};

export default InternationalProvider;
